import React from 'react';

interface TransactionChartProps {
  income: number;
  expenses: number;
}

const TransactionChart: React.FC<TransactionChartProps> = ({ income, expenses }) => {
  const total = income + expenses;
  const incomePercentage = total > 0 ? (income / total) * 100 : 50;
  const expensePercentage = total > 0 ? (expenses / total) * 100 : 50;

  const maxValue = Math.max(income, expenses);
  const incomeHeight = maxValue > 0 ? (income / maxValue) * 100 : 0;
  const expenseHeight = maxValue > 0 ? (expenses / maxValue) * 100 : 0;

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-around h-64 border-b border-gray-200">
        <div className="flex flex-col items-center flex-1 max-w-[200px]">
          <div className="w-full flex items-end justify-center h-full pb-2">
            <div
              className="w-full bg-gradient-to-t from-emerald-500 to-emerald-400 rounded-t-lg transition-all duration-500 flex items-end justify-center pb-4"
              style={{ height: `${incomeHeight}%`, minHeight: '40px' }}
            >
              <span className="text-white font-semibold text-sm">
                {incomeHeight > 15 ? `€${income.toFixed(2)}` : ''}
              </span>
            </div>
          </div>
          <div className="mt-3 text-center">
            <div className="text-sm font-medium text-gray-900">Entrate</div>
            <div className="text-xs text-gray-500">{incomePercentage.toFixed(1)}%</div>
            {incomeHeight <= 15 && (
              <div className="text-sm font-semibold text-emerald-600 mt-1">
                €{income.toFixed(2)}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-center flex-1 max-w-[200px]">
          <div className="w-full flex items-end justify-center h-full pb-2">
            <div
              className="w-full bg-gradient-to-t from-rose-500 to-rose-400 rounded-t-lg transition-all duration-500 flex items-end justify-center pb-4"
              style={{ height: `${expenseHeight}%`, minHeight: '40px' }}
            >
              <span className="text-white font-semibold text-sm">
                {expenseHeight > 15 ? `€${expenses.toFixed(2)}` : ''}
              </span>
            </div>
          </div>
          <div className="mt-3 text-center">
            <div className="text-sm font-medium text-gray-900">Uscite</div>
            <div className="text-xs text-gray-500">{expensePercentage.toFixed(1)}%</div>
            {expenseHeight <= 15 && (
              <div className="text-sm font-semibold text-rose-600 mt-1">
                €{expenses.toFixed(2)}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-700">Entrate</span>
            <span className="text-sm text-gray-600">€{income.toFixed(2)}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
            <div
              className="bg-gradient-to-r from-emerald-500 to-emerald-400 h-full rounded-full transition-all duration-500"
              style={{ width: `${incomePercentage}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-700">Uscite</span>
            <span className="text-sm text-gray-600">€{expenses.toFixed(2)}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
            <div
              className="bg-gradient-to-r from-rose-500 to-rose-400 h-full rounded-full transition-all duration-500"
              style={{ width: `${expensePercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionChart;
